import React, { useEffect, useCallback } from "react";
import { Formik, Form } from "formik";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import * as Yup from "yup";
import { Grid, Button, DialogActions } from "@mui/material";
import { Input, AutoSaveField as Field, CustomSelect } from "../../../../../components/Form";
import { ConfirmDialog } from "../../../../../components/Modals";
import { updateRO, resetSearchResults } from "../../../../../store/actions/searchProspect";
import { getProspectId } from "../../../../../store/selectors/appConfig";
import {
  getRoUpdating,
  getRoUpdateStatus,
  getRoUpdatedType
} from "../../../../../store/selectors/searchProspect";
import { addNotification } from "../../../../../components/Notification";
import { ICONS } from "../../../../../components/Icons";
import { resetProspect, resetRejectReason } from "../../../../../store/actions/appConfig";
import routes from "../../../../../routes";
import { NEXT } from "../../../../../constants";
import { MainContainer } from "./styled";
import { ScrollToError } from "components/ScrollToError";

const searchProspectSchema = Yup.object({
  rejectReason: Yup.string().required("Please select one option"),
  reasonfreeText: Yup.string().max(120, "Maximum 120 characters are allowed")
});

const initialValues = {
  rejectReason: "",
  reasonfreeText: ""
};

export const WithdrawAlert = ({ isOpen, handleCancel, searchedProspectID = "" }) => {
  const selectedProspectedID = useSelector(getProspectId);
  const prospectID = searchedProspectID ? searchedProspectID : selectedProspectedID;
  const roUpdating = useSelector(getRoUpdating);
  const roUpdateStatus = useSelector(getRoUpdateStatus);
  const roUpdatedType = useSelector(getRoUpdatedType);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const withdrawActionType = "withdraw";

  const submittingApplication = values => {
    dispatch(
      updateRO({
        actionType: withdrawActionType,
        prospectID,
        preliminaryCriteria: values,
        saveType: NEXT
      })
    );
  };

  useEffect(() => {
    if (roUpdateStatus !== "" && roUpdateStatus === true && roUpdatedType === withdrawActionType) {
      const successMessageContent = {
        message: "Application successfully withdrawn",
        title: "",
        icon: ICONS.info
      };
      addNotification(successMessageContent);
      dispatch(resetRejectReason());
      handleCancel(false);
      exitApplication();
    } else if (
      roUpdateStatus !== "" &&
      roUpdateStatus === false &&
      roUpdatedType === withdrawActionType
    ) {
      const errorMessageContent = {
        message: "Application withdraw failed",
        title: "",
        icon: ICONS.info
      };
      addNotification(errorMessageContent);
      handleCancel(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roUpdateStatus, roUpdatedType, dispatch, handleCancel]);

  const exitApplication = useCallback(() => {
    dispatch(resetProspect());
    navigate(routes.searchProspect);
    dispatch(resetSearchResults());
  }, [dispatch, navigate]);

  const dialogOptions = (
    <DialogActions sx={{ padding: 1 }}>
      {" "}
      {/* Replaced `classes.noPadding` with `sx` */}
      <Button onClick={() => handleCancel(false)} color="primary" variant="outlined">
        Cancel
      </Button>
      <Button disabled={roUpdating} type="submit" color="primary" variant="contained">
        Withdraw Application
      </Button>
    </DialogActions>
  );

  const DialogMessage = (
    <Formik
      initialValues={initialValues}
      validationSchema={searchProspectSchema}
      validateOnChange={false}
      onSubmit={submittingApplication}
    >
      {({ values, resetForm, setFieldValue }) => (
        <Form>
          <ScrollToError />
          <Grid container sx={MainContainer}>
            <Grid item md={12}>
              <Field
                name="rejectReason"
                label="Withdraw Reason *"
                component={CustomSelect}
                tabIndex="0"
                path="roProspect.preliminaryCriteria.rejectReason"
                datalistId="applRejectReasons"
              />
            </Grid>
            <Grid item md={12}>
              <Field
                name="reasonfreeText"
                label="Withdraw Reason Notes"
                path="roProspect.preliminaryCriteria.reasonfreeText"
                component={Input}
                InputProps={{
                  inputProps: { maxLength: 50, tabIndex: 0 }
                }}
                multiline
                rows="2"
              />
            </Grid>
          </Grid>
          {dialogOptions}
        </Form>
      )}
    </Formik>
  );

  return (
    <ConfirmDialog
      title={null}
      isOpen={isOpen}
      message={DialogMessage}
      actions=""
      divider={false}
    />
  );
};
